/**
 * Global Mediabank object
 */
var Mediabank = {
    App: null,
    DataLayer: null,
    /**
     * Sett current application
     * @param strApp
     */
    setApp: function (strApp) {
        this.App = strApp.toLowerCase();
    },
    /**
     * Set datalayer
     * @param objDataLayer
     */
    setDataLayer: function (objDataLayer) {
        this.DataLayer = objDataLayer;
    },
    /**
     * Get current application
     * @returns {null}
     */
    getApp: function () {
        return this.App;
    },
    /**
     * Get datalayer
     * @returns {null}
     */
    getDataLayer: function () {
        return this.DataLayer;
    },

    getCookie: function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
};

$.ajaxSetup({
    beforeSend: function(xhr, settings) {
        // Only send the token to relative URLs i.e. locally.
        if (settings.type !== 'GET' && !(/^http:.*/.test(settings.url) || /^https:.*/.test(settings.url))) {
            xhr.setRequestHeader('XSRF-TOKEN', Mediabank.getCookie('XSRF-TOKEN'));
        }
    }
});